import {
  Directive,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  Optional,
  PLATFORM_ID,
  Renderer2,
  Self,
  SimpleChanges
}                                          from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { isPlatformBrowser }               from '@angular/common';

import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';

import { Mask }       from '@models/utils/mask';
import { OnChangeFn } from '@models/utils/on-change-fn';


export interface MaskConfig extends Mask {
  inputElement: HTMLInputElement;
}

@Directive({ selector: '[redInputMask]' })
export class InputMaskDirective implements ControlValueAccessor, OnChanges, OnDestroy {

  private readonly isBrowser: boolean;

  private textMaskConfig:     MaskConfig;
  private textMaskController: any;
  private keyupListener:      VoidFunction;
  private blurListener:       VoidFunction;

  public onChange:  OnChangeFn<boolean>;
  public onTouched: VoidFunction;

  @Input() public redInputMask: Mask;
  @Input() public value:        boolean;
  @Input() public disabled:     boolean;

  constructor(
    private renderer:   Renderer2,
    private elementRef: ElementRef,

    @Optional() @Self() public ngControl: NgControl,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.ngControl != null) this.ngControl.valueAccessor = this;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['redInputMask']) {
      const nativeInput: HTMLInputElement = this.elementRef.nativeElement;

      this.clear();

      this.textMaskConfig = {
        inputElement: nativeInput,
        ...this.redInputMask
      };

      this.textMaskController = textMask.maskInput(this.textMaskConfig);

      this.keyupListener = this.renderer.listen(nativeInput, 'keyup', () => {
        this.ngControl.control.setValue(nativeInput.value);
        this.ngControl.control.updateValueAndValidity();
      });

      this.blurListener = this.renderer.listen(nativeInput, 'blur', () => {
        this.ngControl.control.markAsTouched();
        this.ngControl.control.updateValueAndValidity();
      });
    }
  }

  public writeValue(value: boolean) {
    this.value = !!value;
  }

  public registerOnChange(fn: OnChangeFn<boolean>): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: VoidFunction): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private clear(): void {
    if (this.keyupListener) this.keyupListener();
    if (this.blurListener) this.blurListener();
    if (this.textMaskController) this.textMaskController.destroy();
  }

  ngOnDestroy(): void {
    this.clear();
  }

}
